import { render, staticRenderFns } from "./TimeImpactCard.vue?vue&type=template&id=a6cdeb4e&scoped=true"
import script from "./TimeImpactCard.vue?vue&type=script&lang=js"
export * from "./TimeImpactCard.vue?vue&type=script&lang=js"
import style0 from "./TimeImpactCard.vue?vue&type=style&index=0&id=a6cdeb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cdeb4e",
  null
  
)

export default component.exports